export default "__VITE_ASSET__CPFyYErX__"